import { render, staticRenderFns } from "./stock-transfer.vue?vue&type=template&id=c49e6ed8"
import script from "./stock-transfer.vue?vue&type=script&lang=js"
export * from "./stock-transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports